
















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class LoadingButton extends Vue {
  @Prop({ type: Boolean, default: false }) disabled!: boolean;
}
